import { maxWorkflowOffsetAmount, OffsetUnit } from "@sp-crm/core";
import { InlineBanner } from "components/ui/inline-banner";
import { Input } from "components/ui/input";
import { Select } from "components/ui/select";
import { Spinner } from "components/ui/spinner";
import React from "react";
import {
    DelayRecipeEditorControl,
    WAIT_SAVE_FAILURE_MESSAGE,
} from "../delay-recipe-editor";
import { ActionTimingMode, actionTimingMode } from "./builder-helper";

export interface WaitDefault {
    delay: number;
    unit: OffsetUnit;
}

interface WaitModeSelectProps {
    control: DelayRecipeEditorControl;
    defaultWait: WaitDefault;
}

export const WaitModeSelect: React.FC<WaitModeSelectProps> = props => {
    const { control, defaultWait } = props;

    const handleModeChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const newMode = e.target.value as ActionTimingMode;
        if (newMode === "immediately") {
            control.commitDelay(0, "m");
        } else {
            control.commitDelay(defaultWait.delay, defaultWait.unit);
        }
    };

    return (
        <Select
            disabled={!control.editable}
            textSize="sm"
            className="w-36"
            value={actionTimingMode(control.delay)}
            onChange={handleModeChange}>
            <option value="immediately">immediately</option>
            <option value="wait">after a wait</option>
        </Select>
    );
};

interface WaitAmountControlsProps {
    control: DelayRecipeEditorControl;
    minDelay: number;
}

export const WaitAmountControls: React.FC<WaitAmountControlsProps> = props => {
    const { control, minDelay } = props;
    return (
        <>
            <div className="w-20">
                <Input
                    disabled={!control.editable}
                    textSize="sm"
                    type="number"
                    min={minDelay}
                    max={maxWorkflowOffsetAmount(control.unit)}
                    value={control.delay}
                    onChange={control.handleDelayChange}
                    onBlur={control.commitDelayChange}
                />
            </div>
            <Select
                disabled={!control.editable}
                textSize="sm"
                className="w-28"
                value={control.unit}
                onChange={control.handleUnitsChange}>
                <option value="m">minutes</option>
                <option value="h">hours</option>
                <option value="d">days</option>
            </Select>
        </>
    );
};

interface WaitStatusProps {
    control: DelayRecipeEditorControl;
    timeline: string | null;
}

export const WaitStatus: React.FC<WaitStatusProps> = props => {
    const { control, timeline } = props;
    return (
        <>
            {control.pending ? <Spinner /> : null}
            {timeline ? (
                <span className="ml-auto text-xs text-gray-500 whitespace-nowrap">
                    {timeline}
                </span>
            ) : null}
        </>
    );
};

interface WaitSaveFailureProps {
    control: DelayRecipeEditorControl;
}

export const WaitSaveFailure: React.FC<WaitSaveFailureProps> = props => {
    const { control } = props;
    if (!control.failed) {
        return null;
    }
    return <InlineBanner type="error">{WAIT_SAVE_FAILURE_MESSAGE}</InlineBanner>;
};
